export default __webpack_public_path__ + "static/support-c660882cbf197ec26032afe82a4f5504.jpg";